module.exports = __webpack_public_path__ + "static/hh-39c4e2686c5e97c43fe9848af4eed77c.png";